import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  // region Atributos
  private API_URL = environment.url;
  // endregion

  // region Constructor
  constructor(
    private httpClient: HttpClient,
  ) { }
  // endregion

  //#region Métodos

  // Obtiene el listado de usuarios a traves de llamada al backend
  getList(param: 'active' | 'inactive'): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/user/show/${param}`).pipe(map(res => {
      return res;
    }));
  }

  getEnableToLink(): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/user/enable_to_link`).pipe(map(res => {
      return res;
    }));
  }

  getListByGroup(idgroup: number): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/user_group/show/${idgroup}`).pipe(map(res => {
      return res;
    }));
  }

  add(data): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/user/store`, data).pipe(map(res => {
      return res;
    }));
  }

  update(iduser, data): Observable<any> {
    let options: any;

    options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: data
    };

    return this.httpClient.put<any>(`${this.API_URL}/user/${iduser}`, data).pipe(map(res => {
      return res;
    }));
  }

  changeStatus(user_id, status): Observable<any> {
    let data = {
      active: status
    }
    return this.httpClient.put<any>(`${this.API_URL}/user/change_status/${user_id}`, data).pipe(map(res => {
      return res;
    }));
  }

  delete(data): Observable<any> {
    return this.httpClient.delete<any>(`${this.API_URL}/user/${data}`).pipe(map(response => {
      return response;
    }));
  }

  showUsrData(user_id): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/user/${user_id}`).pipe(map(response => {
      return response;
    }));
  }

  saveRecomendation(data): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/recommendation/store`, data).pipe(map(response => {
      return response;
    }));
  }

  //#endregion

}
